export default (function (sliderContainers, args) {
    if ('IntersectionObserver' in window) {
        const sliderObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    import(
                        /* webpackChunkName:"master_slider" */ 'root/main/components/acfModules/masterSlider/masterSliderInitialiser'
                    ).then(module => {
                        return module.default(entry.target, args);
                    });
                    observer.unobserve(entry.target, args);
                }
            });
        });
        sliderContainers.forEach(sliderContainer => {
            sliderObserver.observe(sliderContainer);
        });
    }
});
